<template>
  <div class="modal-sidebar">
    <div class="modal-sidebar__menus" @click="setCurrentTab('profil')">
      PROFIL
    </div>
    <div class="modal-sidebar__menus" @click="setCurrentTab('informasi')">
      INFORMASI
    </div>
    <div
      class="modal-sidebar__menus"
      @click="setCurrentTab('legaldoc')"
      v-if="$get($store, 'state.permissions.34.allow')"
    >
      LEGAL DOKUMEN
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    setCurrentTab(tab) {
      this.$store.dispatch('level1/setCurrentTab', {
        name: tab,
        request_id: this.$store.state.approvalSheet.request_id,
      })
    },
  },
}
</script>
